<!-- @format -->
<syndigo-powerpage
	class="hmf-mb-l hmf-mb-m-xl pdp-content-width margin-auto"
	[attr.pageid]="product?.partNumber">
</syndigo-powerpage>
